Vue.component("Background", {
  mixins: [MediaPathMixin],
  props: ["background", "zoomBackground"],
  template: `
    <div class="background" :style="{transform: zoomBackground ? 'scale(1.25)' : 'scale(1)'}">
        <div class="poster background"></div>
        <video v-if="hasVideo()"
            class="background background--video"
            muted
            autoplay
            loop
            playsinline
            webkit-playsinline
            type="video/mp4"
            :src="videoURL"
            @click="backgroundClicked"
            @dblclick="fullscreen"
            @contextmenu.prevent="">
        </video>
        <div v-if="background.components" class="background-child-component-container">
            <component v-for="(c,i) in background.components" 
              :key="keyGen('bc', i)" 
              :is="c.component" 
              :config="c.props" 
              :style="c.props.style" 
              :class="c.props.cssClass">
            </component>
        </div>
    </div>
    `,
  data() {
    return {
      //default img and video directory for backgrounds for less clutter in manifest.
      // can just be left out.
      imgDirectory: config.BACKGROUND_IMAGE_DIRECTORY || '',
      videoDirectory: config.BACKGROUND_VIDEO_DIRECTORY || '',
      videoPlaying: false,
      currentPoster: "",
    };
  },

  mounted() {

    this.$nextTick().then(()=> {
      this.eventListeners = {};
      this.videoPlaying = false;
      console.log("Background MOUNTED", this.imgURL);

      // The first time we load the application
      // this page will be shown behind the loader, and
      // when it attempts to request its assets they are not guaranteed to
      // be ready.
      // So we listen to the IMAGE_CACHE_READY event the first time around
      // so we can create our poster image
      window.app.radio.$on("IMAGE_CACHE_READY", () => {
        console.log("IMAGE_CACHE_READY", this.videoPlaying, this.imgURL);
        this.createPoster();
      });

      // Then subsequential changes of the scene we can just
      if ("ImageCache" in window.app) {
        window.app.ImageCache.done().then(() => {
          this.createPoster();
        });
      }



      console.log("This page has a video: ", this.hasVideo(), this.background)
      if (this.hasVideo()) {
        var video = this.$el.querySelector("video");
        if (video) {
          
          this.eventListeners["playing"] = () => {
            this.videoPlaying = true;
          };
          video.addEventListener("playing", this.eventListeners["playing"]);


          setTimeout(()=> {

            console.log("testing video state", video.paused)
            if(video.paused) {
                video.play();
                this.videoPlaying = true;

            }else {
              this.videoPlaying = true;
            }
        }, 1000);
        }
      }
    })
  },

  destroyed() {
    if (this.hasVideo()) {
      var video = this.$el.querySelector("video");
      if (video) {
        Object.keys(this.eventListeners).forEach((event) => {
          video.removeEventListener(event, this.eventListeners[event]);
        });
      }
    }
  },

  computed: {
    videoURL() {
      return this.videoDirectory + this.background.video;
    },
    imgURL() {
      return this.imgDirectory + this.background.img;
    },
   
  },
  methods: {
    keyGen (prefix, index) {
      return prefix + "-" + index
    },
    hasVideo() {
      return (
        this.background.hasOwnProperty("video") &&
        this.background.video !== "" &&
        this.background.video !== false
      );
    },
    fullscreen() {
      this.$emit("fullscreen");
    },
    backgroundClicked() {
      this.$emit("closeAllContent");
    },
    createPoster() {
      // NOTE(Mølby) Iteration note: I'm adding the img regardless of the video playing or not. Because, on slow connectections the background color of the video element is shown if the video is slow to render first frame.
      // In moved the video layer above the poster layer and made the video transparent. The first frame is always present underneath, the video takes over when it is ready.
      var imgUrlIsCorrectlyFormed = /(\.jpg|\.png)/.test(this.imgURL);
      if (imgUrlIsCorrectlyFormed)
      {
        console.log("creating poster");
        this.currentPoster = this.imgURL;
        var img = app.ImageCache.getAsset(this.imgURL).content;

        // NOTE: Delete all children of poster element
        Array.from(this.$el.querySelector(".poster").children).forEach((o) =>
          o.remove()
        );

        // NOTE: Append the preloaded image object
        this.$el.querySelector(".poster").appendChild(img);
      }
    },
  },
});
